import { Hammer, Wrench, HardHat, Construction } from "lucide-react";

export const StaffProfile = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-orange-50 flex items-center justify-center p-6">
            <div className="max-w-2xl w-full">
                {/* Main Card */}
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                    {/* Animated Header */}
                    <div className="bg-gradient-to-r from-yellow-400 to-orange-400 p-8 relative overflow-hidden">

                        <div className="relative flex items-center justify-center">
                            <Construction className="h-20 w-20 text-white animate-bounce" />
                        </div>

                        <h1 className="text-4xl font-bold text-white text-center mt-4 relative">
                            Page Under Construction
                        </h1>
                        <p className="text-white text-center mt-2 text-lg relative">
                            We're building something awesome!
                        </p>
                    </div>

                    {/* Body Content */}
                    <div className="p-8">
                        {/* Spinning Icons */}
                        <div className="flex justify-center space-x-6 mb-8">
                            <div className="animate-spin" style={{ animationDuration: '3s' }}>
                                <Hammer className="h-12 w-12 text-yellow-500" />
                            </div>
                            <div className="animate-pulse">
                                <HardHat className="h-12 w-12 text-orange-500" />
                            </div>
                            <div className="animate-spin" style={{ animationDuration: '3s', animationDirection: 'reverse' }}>
                                <Wrench className="h-12 w-12 text-yellow-500" />
                            </div>
                        </div>

                        {/* Progress Bar */}
                        <div className="mb-8">
                            <div className="flex justify-between text-sm text-gray-600 mb-2">
                                <span>Building your profile...</span>
                                <span>Coming Soon!</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                                <div className="bg-gradient-to-r from-yellow-400 to-orange-400 h-3 rounded-full w-3/4 animate-pulse"></div>
                            </div>
                        </div>

                        {/* Message Box */}
                        <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 mb-8">
                            <h3 className="text-lg font-semibold text-blue-900 mb-3">
                                👷‍♂️ Meanwhile...
                            </h3>
                            <p className="text-blue-700 mb-4">
                                While this page is in progress, please use the Staff Portal to make changes for now.
                            </p>
                        </div>

                        {/* Fun Facts */}
                        <div className="text-center text-gray-600">
                            <p className="text-sm">
                                🔨 Our developers are working hard to bring you an amazing profile experience!
                            </p>
                            <p className="text-xs mt-2 text-gray-400">
                                Estimated completion: Very Soon™
                            </p>
                        </div>
                    </div>
                </div>

                {/* Floating Construction Signs */}
                <div className="mt-8 flex justify-center space-x-4">
                    <div className="bg-yellow-400 text-yellow-900 px-3 py-1 rounded-md text-xs font-bold transform -rotate-3 hover:rotate-0 transition-transform">
                        CAUTION
                    </div>
                    <div className="bg-orange-400 text-orange-900 px-3 py-1 rounded-md text-xs font-bold transform rotate-2 hover:rotate-0 transition-transform">
                        WORK IN PROGRESS
                    </div>
                    <div className="bg-yellow-400 text-yellow-900 px-3 py-1 rounded-md text-xs font-bold transform -rotate-2 hover:rotate-0 transition-transform">
                        HARD HAT AREA
                    </div>
                </div>
            </div>
        </div>
    );
};